var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeeMaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.24984V4.83317H24.1667V2.4165H7.25004C5.92087 2.4165 4.83337 3.504 4.83337 4.83317V24.1665C4.83337 25.4957 5.92087 26.5832 7.25004 26.5832H24.1667V24.1665H19.2971C20.0565 23.6098 20.6743 22.8822 21.1004 22.0426C21.5265 21.2029 21.7491 20.2748 21.75 19.3332V13.2915H9.66671V19.3332C9.66671 21.3148 10.6455 23.0669 12.1196 24.1665H7.25004V4.83317H9.66671V7.24984C9.66671 7.91442 10.2105 8.45817 10.875 8.45817H20.5417C21.2063 8.45817 21.75 7.91442 21.75 7.24984ZM15.7084 9.6665C16.373 9.6665 16.9167 10.2103 16.9167 10.8748C16.9167 11.5394 16.373 12.0832 15.7084 12.0832C15.0438 12.0832 14.5 11.5394 14.5 10.8748C14.5 10.2103 15.0438 9.6665 15.7084 9.6665Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMaker);
export default __webpack_public_path__ + "static/media/coffee-maker.46d8470e14e028632f16a1df93fccd61.svg";
export { ForwardRef as ReactComponent };